import { render, staticRenderFns } from "./EditParent.vue?vue&type=template&id=6be5ca42&"
import script from "./EditParent.vue?vue&type=script&lang=js&"
export * from "./EditParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports